import React from "react";
import ReactDOM from "react-dom";
import Notice from "../../contracts/Notice.json";
import { Container, Row, Col, Card, Button } from "react-bootstrap";
import { BrowserRouter as Router, Routes, Route, Link } from "react-router-dom";

// import Insurance from "./contracts/Insurance.json";
import Web3 from "web3";

export default class Admin extends React.Component {
  constructor(props) {
    super(props);

    this.makeNotice = this.makeNotice.bind(this);
    this.state = {
      id: "",
      message: "",
      message2: "",
      hospital_name: "",
      hospital_address: "",
      vaccine_doses: "",
      icu: "",
      ventilators: "",
      oxygen_cylinders: "",
      Notices: [],
    };
  }

  async makeNotice(event) {
    event.preventDefault();
    const web3 = new Web3(Web3.givenProvider || "http://localhost:8545");
    const accounts = await web3.eth.getAccounts();
    const networkId = await web3.eth.net.getId();
    const deployedNetwork = Notice.networks[networkId];
    const instance = new web3.eth.Contract(
      Notice.abi,
      deployedNetwork && deployedNetwork.address
    );

    this.state.oxygen_cylinders = Number(this.state.oxygen_cylinders);
    this.state.vaccine_doses = Number(this.state.vaccine_doses);
    this.state.ventilators = Number(this.state.ventilators);
    this.state.icu = Number(this.state.icu);

    console.log(typeof this.state.oxygen_cylinders);

    await instance.methods
      .newInfo(
        this.state.hospital_name,
        this.state.hospital_address,
        this.state.oxygen_cylinders,
        this.state.vaccine_doses,
        this.state.ventilators,
        this.state.icu
      )
      .send({ from: accounts[0], gas: 2100000 });
    this.setState({ message2: "Notice sent!" });
    console.log("notice sent!!");
    const data = {
      hp_name: this.state.hospital_name,
      hp_add: this.state.hospital_address,
      oxy_cylinders: this.state.oxygen_cylinders,
      vaccine_doses: this.state.vaccine_doses,
      ventilators: this.state.ventilators,
      icu: this.state.icu,
    };

    this.setState({
      Notices: [...this.state.Notices, data],
    });
    console.log(data)
    console.log(this.state.Notices)
    localStorage.setItem("Notices", JSON.stringify(this.state.Notices));
  }

  // async listen(fromBlockNumber = "latest") {
  //   console.log("Listening for events");
  //   const web3 = new Web3(Web3.givenProvider || "http://localhost:8545");
  //   const accounts = await web3.eth.getAccounts();
  //   const networkId = await web3.eth.net.getId();
  //   const deployedNetwork = Notice.networks[networkId];
  //   const instance = new web3.eth.Contract(
  //     Notice.abi,
  //     deployedNetwork && deployedNetwork.address
  //   );
  //   instance.events.emitnotice(
  //     {
  //       fromBlock: fromBlockNumber,
  //     },
  //     (err, contractEvent) => {
  //       if (err) {
  //         console.error("listener error", err);
  //         return;
  //       }
  //       console.log("Heard something!");
  //       console.log("this is from the listener script");
  //       const { event, returnValues, blockNumber } = contractEvent;
  //       const {
  //         hospital_name,
  //         hospital_address,
  //         date,
  //         cylinders,
  //         vaccine_doses,
  //         ventilators,
  //         icu,
  //       } = returnValues;
  //       console.log(
  //         `${event}: At block ${blockNumber} there is a notice from ${hospital_name} at ${hospital_address} where there are ${cylinders} oxygen cylinders, ${vaccine_doses} vaccine doses, ${ventilators} ventilators and ${icu} icu's at ${date}`
  //       );
  //     }
  //   );
  // }

  render() {
    return (
      <div className="container container-fluid login-conatiner">
        <div style={{ padding: "5px" }}>
          <div className="d-flex flex-row-reverse btn btn-dark btn-lg btn-block">
            <Link to="/logout">
              <Button variant="secondary">Logout</Button>
            </Link>{" "}
            <Link style={{ marginRight: "1100px" }} to="/admin/home">
              <Button variant="secondary">Home</Button>
            </Link>{" "}
          </div>
        </div>
        <div className="outer">
          <div className="inner">
            <form>
              <h3>New Notification</h3>

              <div className="form-group">
                {/* <label>First name</label> */}
                <input
                  type="text"
                  value={this.state.hospital_name}
                  onChange={(event) =>
                    this.setState({ hospital_name: event.target.value })
                  }
                  className="form-control"
                  placeholder="hospital_name"
                />
              </div>

              <div className="form-group">
                {/* <label>Last name</label> */}
                <input
                  type="text"
                  value={this.state.hospital_address}
                  onChange={(event) =>
                    this.setState({ hospital_address: event.target.value })
                  }
                  className="form-control"
                  placeholder="hospital_address"
                />
              </div>

              <div className="form-group">
                {/* <label>Email</label> */}
                <input
                  type="number"
                  value={this.state.oxygen_cylinders}
                  onChange={(event) =>
                    this.setState({ oxygen_cylinders: event.target.value })
                  }
                  className="form-control"
                  placeholder="oxygen_cylinders"
                />
              </div>

              <div className="form-group">
                {/* <label>Password</label> */}
                <input
                  type="number"
                  value={this.state.vaccine_doses}
                  onChange={(event) =>
                    this.setState({ vaccine_doses: event.target.value })
                  }
                  className="form-control"
                  placeholder="vaccine_doses"
                />
              </div>
              <div className="form-group">
                <input
                  type="number"
                  value={this.state.ventilators}
                  onChange={(event) =>
                    this.setState({ ventilators: event.target.value })
                  }
                  className="form-control"
                  placeholder="ventilators"
                />
              </div>
              <div className="form-group">
                <input
                  type="number"
                  value={this.state.icu}
                  onChange={(event) =>
                    this.setState({ icu: event.target.value })
                  }
                  className="form-control"
                  placeholder="icu"
                />
              </div>
              <div className="form-group">
                <button
                  className="btn btn-dark btn-lg btn-block"
                  style={{ marginLeft: "37.5%" }}
                  onClick={this.makeNotice}
                >
                  Submit
                </button>
              </div>
              <div className="clearfix" />
            </form>
          </div>
        </div>
      </div>
    );
  }
}
